/* istanbul ignore file */

import { css } from 'styled-components';

export const shadowUp = css`
  box-shadow: 0 -6px 8px -4px rgba(0, 0, 0, 0.2);
`;

export const shadowDown = css`
  box-shadow: 0 6px 8px -4px rgba(0, 0, 0, 0.2);
`;

export const shadowRight = css`
  box-shadow: 6px 0px 8px -4px rgba(0, 0, 0, 0.2);
`;
